import React from 'react';
import { Trans } from 'react-i18next';
import { call, put, select, race, take } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client/pkg/request';
import { getCurrentGallection, getGallectionById, getGrusername } from '../selectors';
import { deselectAll } from '../actions';
import setGallectionCover from './setGallectionCover';
import updateGallectionSize from './updateGallectionSize';
import { isPremiumGallection, getPremiumGallectionType } from '../../utils/gallections';
import { pushGlobalConfirmationModalForMM, confirmYes, confirmNo } from '../../Modals/redux/actionCreators';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations';
import { checkAndWarnIfDeviationsAreNotSupportedForPremium } from './helpers';
import { getGallectionType } from '../helpers';
export default function*(action) {
    const { deviations, targetFolderId } = action.payload;
    const { currentGallection, targetGallection, username } = yield select((state)=>({
            currentGallection: getCurrentGallection(state),
            targetGallection: getGallectionById(state, targetFolderId),
            username: getGrusername(state)
        }));
    const type = getGallectionType(currentGallection);
    if (!currentGallection || !targetGallection || !type || type === 'stash') {
        return;
    }
    const isFromPremiumFolder = isPremiumGallection(currentGallection);
    const isToPremiumFolder = isPremiumGallection(targetGallection);
    if (!isFromPremiumFolder && isToPremiumFolder) {
        const hasUnsupportedDeviationSelected = yield call(checkAndWarnIfDeviationsAreNotSupportedForPremium, deviations);
        if (hasUnsupportedDeviationSelected) {
            return;
        }
        const premiumType = getPremiumGallectionType(targetGallection);
        let confirmationTextTransKey;
        if (premiumType === 'paid') {
            confirmationTextTransKey = /*#__PURE__*/ React.createElement(Trans, {
                i18nKey: "mediapopup.confirmationPopup.moveDeviation.text.fromRegularToPaid"
            }, "• Only your paying Supporters will have access to it.", /*#__PURE__*/ React.createElement("br", null), "• It will become locked for all your non-Supporters and will affect Collections, Groups, Profile Spotlights,", ' ', /*#__PURE__*/ React.createElement("a", {
                href: "https://www.deviantartsupport.com/en/article/what-happens-when-i-move-deviations-in-or-out-of-premium-galleries"
            }, "and more"), ".", /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("br", null), "Are you sure you want to move this deviation?");
        } else {
            confirmationTextTransKey = /*#__PURE__*/ React.createElement(Trans, {
                i18nKey: "mediapopup.confirmationPopup.moveDeviation.text.fromRegularToWatchersOnly"
            }, "• Only your watchers will have access to it.", /*#__PURE__*/ React.createElement("br", null), "• It will become locked for deviants who don’t watch you and will affect Collections, Groups, Profile Spotlights,", ' ', /*#__PURE__*/ React.createElement("a", {
                href: "https://www.deviantartsupport.com/en/article/what-happens-when-i-move-deviations-in-or-out-of-premium-galleries"
            }, "and more"), ".", /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("br", null), "Are you sure you want to move this deviation?");
        }
        yield put(pushGlobalConfirmationModalForMM({
            titleTransKey: 'mediapopup.confirmationPopup.moveDeviation.title',
            textTransKey: confirmationTextTransKey,
            confirmBtnLabelTransKey: 'mediapopup.confirmationPopup.moveDeviation.confirm',
            cancelBtnLabelTransKey: 'popup.cancel',
            icon: /*#__PURE__*/ React.createElement(Warning, null)
        }));
        const { no } = yield race({
            yes: take(confirmYes),
            no: take(confirmNo)
        });
        if (no) {
            return;
        }
    }
    yield put(deselectAll());
    yield call(setGallectionCover, {
        gallection: targetGallection,
        deviation: deviations[0],
        onlyIfMissing: true
    });
    yield call(updateGallectionSize, targetFolderId, deviations.length);
    const deviationIds = deviations.map((deviation)=>deviation.deviationId);
    const params = {
        username,
        type,
        target_folderid: targetFolderId,
        deviationids: deviationIds
    };
    yield call(requestPuppy, {
        method: 'post',
        url: 'gallection/folders/copy_deviations',
        data: params
    });
}

//# sourceMappingURL=copyDeviations.js.map